<template>
  <button-tooltip tooltip-text="Export to PDF">
    <button @click.stop="exportToPdf">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="text-black-600 hover:text-grey-700"
      >
        <path
          d="M19.4288 7.00012V19.7143C19.4288 20.8189 18.5334 21.7143 17.4288 21.7143H7.14307C6.0385 21.7143 5.14307 20.8189 5.14307 19.7143V4.28577C5.14307 3.1812 6.0385 2.28577 7.14307 2.28577H15.0002M19.4288 7.00012L15.0002 2.28577M19.4288 7.00012H16.0002C15.4479 7.00012 15.0002 6.55241 15.0002 6.00012V2.28577M12.2859 8.8572V16.0001M12.2859 16.0001L15.1431 13.4286M12.2859 16.0001L9.14307 13.4286"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </button-tooltip>
</template>

<script>
import ButtonTooltip from "@/components/utils/ButtonTooltip.vue";

export default {
  name: "ExportPdf",
  components: {
    ButtonTooltip,
  },
  methods: {
    exportToPdf() {
      this.$emit("export-to-pdf");
    },
  },
};
</script>
